export default __webpack_public_path__ + "static/Retail-Analytics-5c0da65443f4c288f61641970ce1f6d7.webp";